import { render, staticRenderFns } from "./NewPasswordView.vue?vue&type=template&id=e86f3c96&scoped=true"
import script from "./NewPasswordView.vue?vue&type=script&lang=js"
export * from "./NewPasswordView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86f3c96",
  null
  
)

export default component.exports